import UnderMaintenanceScreen from './MaintenanceScreen';

export default UnderMaintenanceScreen;
